import React from 'react';
import { Navigate } from 'react-router-dom';

import { ProtectedRouteProps } from '../interface/interface';
import { getUser, isAuthenticated } from '../services/service';

const PublicRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  if (!isAuthenticated()) {
    return <>{children}</>;
  }

  const user = getUser();

  // getUser() may invalidate a stale session (missing/corrupt user).
  if (!user || !isAuthenticated()) {
    return <>{children}</>;
  }

  if (user.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return <Navigate to="/" replace />;
};

export default PublicRoute;
